import { ChangeDetectionStrategy, Component, InjectionToken, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { MdlDialogReference } from '@angular-mdl/core';
import { CourierModel, SampleActivity, CourierDetails } from './courier-model';
import { CourierModelService } from './courier-model-service';
import { forkJoin } from 'rxjs';
import { filter } from 'rxjs/operators';
import { GridHeader } from '../../sample-tracking/tracking-overview/interfaces/grid';
export const COURIER_MODEL_TOKEN = new InjectionToken('CourierModelItem');

@Component({
    selector: 'courier-model',
    template: require('./courier-model.component.html'),
    styles: [require('./courier-model.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CourierModelComponent implements OnInit {

    public courierModel: CourierModel;
    public numberOfSamples?: string;
    public activityDetails: SampleActivity[] = [];
    public courierDetailsInfo: CourierDetails;
    public courierInfo: { header: any, data: CourierDetails };
    public isLoadingCompleted = false;
    public activityHeader: GridHeader[];

    constructor(
        private readonly dialogRef: MdlDialogReference,
        private readonly modelService: CourierModelService,
        private changeDectectorRef: ChangeDetectorRef,
        @Inject(COURIER_MODEL_TOKEN) private readonly courierData: CourierModel) {

        this.courierModel = courierData;
    }

    public ngOnInit() {
        this.modelService.getCourierModelData(this.courierModel.lgxCourierShipmentId, this.courierModel.isSponsorModel)
            .pipe(
                filter((courierData) => !!courierData)
            )
            .subscribe((courierData) => {
                courierData.shipmentStatus = this.courierModel.shipmentStatus;
                this.courierDetailsInfo = courierData;
                this.numberOfSamples = this.courierModel.numberOfSamples;
                this.courierInfo = { header: this.modelService.getCourierDetailsHeader(), data: courierData };
                this.activityDetails = courierData.formatedCourierData;
                this.activityHeader = this.modelService.getShipmentActivityHeader();
                this.isLoadingCompleted = true;
                this.changeDectectorRef.markForCheck();
            });
    }

    public onCancel() {
        this.dialogRef.hide();
    }
}